import Resource from "../../Entity/Resource";
import Document from "../../Entity/Document";

export default class CreateDownloadFromResourceRequest {
    public constructor(
        private readonly resource: Resource,
        private readonly documents: Document[],
        private readonly sessionToken: string
    ) {}

    public getResource(): Resource {
        return this.resource;
    }

    public getDocuments(): Document[] {
        return this.documents;
    }

    public getSessionToken(): string {
        return this.sessionToken;
    }
}